import { VersionDisplay } from '@/components/VersionDisplay'
import { ThemeToggle } from '@/components/ui/ThemeToggle'
import { Button } from '@/components/ui/button'
import { Menu } from 'lucide-react'

interface HeaderProps {
  onMenuClick?: () => void
}

export function Header({ onMenuClick }: HeaderProps) {
  return (
    <header className="h-16 px-4 lg:px-6 bg-card border-b border-border flex items-center justify-between">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden"
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <Menu className="size-5" />
        </Button>
        <h1 className="text-xl font-semibold text-card-foreground">Strive</h1>
      </div>

      <div className="flex items-center gap-4">
        <ThemeToggle />
        <VersionDisplay variant="compact" />
      </div>
    </header>
  )
}
